export default __webpack_public_path__ + "static/media/cloud-moon-rain.f6a802c7.svg";